import { render, staticRenderFns } from "./WhatsAppProtocol.vue?vue&type=template&id=55ce94b4"
import script from "./WhatsAppProtocol.vue?vue&type=script&lang=js"
export * from "./WhatsAppProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports